import React from 'react';
import HeroSection from '../../HeroSection';
import Pricing from '../../Pricing';
import { homeObjOne, homeObjThree, homeObjTwo, homeObjFour } from './Data';

function SignUp() {
    return (
        <>
          
          
          <HeroSection {...homeObjThree} /> 

        </>
    )   
}

export default SignUp;
